import { render, staticRenderFns } from "./SetChronicAlert.vue?vue&type=template&id=4facf43d"
import script from "./SetChronicAlert.vue?vue&type=script&lang=js"
export * from "./SetChronicAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports